import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { getDisplayNamePrimaryWithSpecialProHealthRule } from '../../../../core/util/location';
import { fontFamily, fontSize } from '../../../../constants/text';
import { colors } from '../../../../constants/colors';
import { smallerThanOrEqualTo, biggerThan } from '../../../../core/util/styledComponents';

const Root = styled.div.withConfig({ componentId: 'sc-17efrsb-0' })`
  display: flex;
  justify-content: space-between;
  ${smallerThanOrEqualTo.md`
    margin: 0 10px 10px 20px;
  `};
  ${biggerThan.md`
    margin: 0 4px;
  `};
`;

const Title = styled.div.withConfig({ componentId: 'sc-17efrsb-1' })`
  font-family: ${fontFamily.book};
  ${smallerThanOrEqualTo.md`
    color: ${colors.lanaDelGrey};
    font-size: ${fontSize.mediumSmall};
    line-height: 1.5em
  `};
  ${biggerThan.md`
   color: ${colors.fadeToBlack};
   font-size: 15px;
   line-height: 16px;
  `};
`;

type Props = {
  location: any;
};

const SectionTitle = ({ location }: Props) => {
  const { t } = useTranslation('bookingWidget');
  return (
    <Root>
      <Title>
        {t('haveYouBeenHereBefore.title', {
          location_name: getDisplayNamePrimaryWithSpecialProHealthRule(location).toUpperCase(),
        })}
      </Title>
    </Root>
  );
};

export default SectionTitle;
